import React from 'react'
import { useNavigate } from 'react-router-dom'
import { motion } from 'framer-motion';
import { fadeIn, staggerContainer } from '../../../utils/motion';

import img from '../../../assets/career.webp'

const CareerHeader = () => {

    const navigate = useNavigate()

    return (
        <div className='main-class'>

            <motion.div
                variants={staggerContainer}
                initial="hidden"
                whileInView="show"
                viewport={{ once: true }}>
                <div className='grid grid-cols-1 md:grid-cols-2  md:gap-4'>
                    <motion.div
                        variants={fadeIn('right', 'tween', 0, 1.0)}
                    >
                        <div className='p-2'>
                            <h1 className='font-bold text-2xl text-center md:text-left md:text-3xl dark:text-white'><span className='text-red-500'>Careers at </span>- CodeZone</h1>
                            <h6 className='text-sm font-bold mt-2 dark:text-white'>
                                Are you passionate about building your career with opportunities to learn and lead?
                            </h6>
                            <p className='my-4 md:my-5 text-gray-500 dark:text-gray-300 text-xs'>
                                Join us at CodeZone - a multinational software development company based scopes in all around the world which includes China, USA, Canada, Australia and UK.
                            </p>
                        </div>
                    </motion.div>
                    <motion.div
                        variants={fadeIn('left', 'tween', 0, 1.0)}
                    >
                        <div className='flex items-center justify-center'>
                            <img src={img} alt="img"
                                className='object-contain cursor-pointer h-[280px] w-[80%] md:w-full'
                                onClick={() => navigate('/pricing')}
                            />
                        </div>
                    </motion.div>
                </div>
            </motion.div>
        </div>
    )
}

export default CareerHeader